export var FinanceRoleType;
(function (FinanceRoleType) {
    FinanceRoleType["NOT_DEPOSIT_ONLINE"] = "not_deposit_online";
    FinanceRoleType["NOT_DEPOSIT_ERC20"] = "not_deposit_erc20";
    FinanceRoleType["NOT_DEPOSIT_TRC20"] = "not_deposit_trc20";
    FinanceRoleType["NOT_DEPOSIT_SCAN_WECHAT"] = "not_deposit_scan_wechat";
    FinanceRoleType["NOT_DEPOSIT_SCAN_ALIPAY"] = "not_deposit_scan_alipay";
    FinanceRoleType["NOT_DEPOSIT_GOUBOU"] = "not_deposit_goubao";
    FinanceRoleType["NOT_DEPOSIT_TOPAY"] = "not_deposit_topay";
    FinanceRoleType["NOT_DEPOSIT_EBPAY"] = "not_deposit_ebpay";
    FinanceRoleType["NOT_DEPOSIT_ONLINE_MANUAL"] = "not_deposit_online_manual";
    FinanceRoleType["NOT_DEPOSIT_CGPAY"] = "not_deposit_cgpay";
    FinanceRoleType["NOT_DEPOSIT_UNION_PAY_QUICK"] = "not_deposit_union_pay_quick";
    FinanceRoleType["NOT_DEPOSIT_UNION_PAY_CLOUD"] = "not_deposit_union_pay_cloud";
    FinanceRoleType["NOT_DEPOSIT_KOIPAY"] = "not_deposit_koipay";
    FinanceRoleType["NOT_DEPOSIT_ECNY"] = "not_deposit_e_cny";
    FinanceRoleType["NOT_DEPOSIT_PAY808"] = "not_deposit_pay808";
    FinanceRoleType["NOT_DEPOSIT_PAY988"] = "not_deposit_pay988";
    FinanceRoleType["NOT_DEPOSIT_KDPAY"] = "not_deposit_kdpay";
    FinanceRoleType["NOT_WITHDRAW_DEBIT_CARD"] = "not_withdraw_debit_card";
    FinanceRoleType["NOT_WITHDRAW_ERC20"] = "not_withdraw_erc20";
    FinanceRoleType["NOT_WITHDRAW_TRC20"] = "not_withdraw_trc20";
    FinanceRoleType["NOT_WITHDRAW_GOUBOU"] = "not_withdraw_goubao";
    FinanceRoleType["NOT_WITHDRAW_TOPAY"] = "not_withdraw_topay";
    FinanceRoleType["NOT_WITHDRAW_EBPAY"] = "not_withdraw_ebpay";
    FinanceRoleType["NOT_WITHDRAW_CGPAY"] = "not_withdraw_cgpay";
    FinanceRoleType["NOT_WITHDRAW_CGPAY_USDT"] = "not_withdraw_cgpay_usdt";
    FinanceRoleType["NOT_WITHDRAW_KOIPAY"] = "not_withdraw_koipay";
    FinanceRoleType["NOT_WITHDRAW_PAY808"] = "not_withdraw_pay808";
    FinanceRoleType["NOT_WITHDRAW_PAY988"] = "not_withdraw_pay988";
    FinanceRoleType["NOT_WITHDRAW_KDPAY"] = "not_withdraw_kdpay";
    FinanceRoleType["NOT_WITHDRAW_ALIPAY"] = "not_withdraw_alipay";
    FinanceRoleType["NOT_WITHDRAW_AGENT_TRANSFER_WITHDRAW"] = "not_withdraw_agent_transfer_withdraw";
})(FinanceRoleType || (FinanceRoleType = {}));
//# sourceMappingURL=FinanceRoleType.js.map